export enum ReportPermissions {
  ALL = "Travel:Reports:*",
  READ = "Travel:Reports:Read",
  EXPORT = "Travel:Reports:Export",
}

export function hasReportAccess(userPermissions: string[]): boolean {
  return userPermissions.some((p) =>
    [ReportPermissions.READ, ReportPermissions.ALL, "*"].includes(p)
  );
}
